<head>
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
</head>
<mat-accordion *ngIf="isError;else infoMessage">
  <!-- {{data?.type}} -->
  <!-- [ngClass]="{bgcolorblack: !isDarkTheme(), bgcolorwhite:isDarkTheme()}" -->
  <mat-expansion-panel class="mat-elevation-z0"
    (opened)="panelOpenState = true" (closed)="panelOpenState = false" expanded hideToggle>
    <mat-expansion-panel-header [collapsedHeight]="customCollapsedHeight" [expandedHeight]="customExpandedHeight" >

      <mat-panel-description class="infoMessagecenter" fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
        <div *ngIf="data.iconname" fxLayout fxFlex="10" fxLayoutAlign="center center">
          <mat-icon [ngClass]="{'iconWarning': data?.type == 'warning',
          'iconInfo': data?.type == 'information',
          'iconError': data?.type == 'error'}">{{ data.iconname }}</mat-icon>
        </div>
        <div *ngIf="data.iconname" fxFlex="2"></div>
        <div [fxFlex]="data.iconname ? '88' : '100'">
          <span class="has-spoiler"
            [matTooltip]="(data?.message && data?.message.length > 200) ? data?.message : null">
            {{ data?.message?.length > 200 ? (data?.message | slice:0:200) + '...' : data?.message || '' }}
          </span>
          <span class="spoiler-span">
            <details class="spoiler-span">
              <summary (click)="$event.stopPropagation();">Show more</summary>
              <div class="details-content">
                <p>{{ data.title }}: {{ data.description }}</p>
              </div>
            </details>
          </span>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <!-- [ngClass]="{errorMessageblack: !isDarkTheme(),errorMessagewhite:isDarkTheme()}" -->
    <div>
      {{data?.recommendation || ""}}
    </div>
  </mat-expansion-panel>
</mat-accordion>
<button class="iconButtonColor" *ngIf="snackBarRef.containerInstance.snackBarConfig.duration==undefined || !data?.duration"
  [ngClass]="{'icon-button-small-close': !panelOpenState,'icon-button-small-open':panelOpenState}" mat-icon-button
  (click)="snackBarRef.dismiss()">
  <mat-icon>close</mat-icon>
</button>
<ng-template #infoMessage>
  <div class="infoMessagecenter" fxLayout="row" fxLayoutGap="10px">
    <div>
      <mat-icon>{{ data.iconname }}</mat-icon>
    </div>
    <p>{{ data.message }}</p>
  </div>
</ng-template>
